import {Stack, Typography} from "@mui/material";
import {MyDropZone} from "./styles";
import React, {Fragment, useState} from "react";
import AdvancedFileManager from "./advanced-file-manager.component";
import {useTranslation} from "react-i18next";

interface ComponentProps {
    value: any;
    onChange: (convertedFile: any) => any;
}

export default function SingleImageUpload({value, onChange}: ComponentProps) {
    const [isOpenMediaManager, setIsOpenMediaManager] = useState<boolean>(false);

    const handleImageItemClick = (url: string) => onChange(url);

    return <Fragment>
        <Stack flexDirection="row" flexWrap={"wrap"} sx={{width: "100%"}} gap={2}>
            <div>
                <img
                    src={value}
                    alt="Tölts fel egy képet!"
                    width={150}
                    height={150}
                    style={{objectFit: "cover"}}
                />
            </div>

            <MyDropZone onClick={() => setIsOpenMediaManager(!isOpenMediaManager)}>
                <Typography variant="body1">
                    Kattints ide vagy húzd ide a képet a feltöltéshez!
                </Typography>
            </MyDropZone>
        </Stack>

        <AdvancedFileManager
            isOpen={isOpenMediaManager}
            handleClose={() => setIsOpenMediaManager(!isOpenMediaManager)}
            handleAudioFileSelection={() => {
            }}
            handleImageFileSelection={handleImageItemClick}
        />
    </Fragment>
}
